import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { interval } from 'rxjs';
import { SignService } from 'src/app/sign/sign.service';

@Component({
  selector: 'app-sign-modal',
  templateUrl: './sign-modal.component.html',
  styleUrls: ['./sign-modal.component.scss'],
  standalone: false
})
export class SignModalComponent implements OnInit {
  url: string;

  @ViewChild('iframe', { static: true }) iframe: ElementRef;

  constructor(
    private signService: SignService,
    private dialogRef: MatDialogRef<SignModalComponent>,
  ) { }

  ngOnInit(): void {
    this.url = this.signService.getUrl();
  }

  onRedirect() {
    this.dialogRef.close(true);
  }

  loadEvent(event) {
    console.log(event);
  }
}
